import { render, staticRenderFns } from "./LectureContentNavigation.vue?vue&type=template&id=0ea8389c&"
import script from "./LectureContentNavigation.vue?vue&type=script&lang=js&"
export * from "./LectureContentNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports